import React from 'react';

import { styled } from '@mui/material/styles';

const ContainerBase = styled('div')`
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 8px);
  margin: -4px;
  box-sizing: border-box;
`;

const ItemBase = styled('div')`
  padding: 4px;
  box-sizing: border-box;
  margin: 0;
`;

export class HomeGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDisplay: true,
    };
  }

  calcStyle = () => {
    //see https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Grid/Grid.js

    const { gridSize, item, fixedWidth } = this.props;

    const display = this.state.isDisplay ? 'block' : 'none';

    if (gridSize === 'auto') {
      return {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%',
        display: item ? display : 'block',
      };
    }

    if (gridSize === 'fixed') {
      return {
        flexBasis: fixedWidth,
        flexGrow: 0,
        maxWidth: fixedWidth,
        display: item ? display : 'block',
      };
    }

    if (typeof gridSize === 'function') {
      const width = `${Math.round((gridSize() / 12) * 10e7) / 10e5}%`;

      return {
        flexBasis: width,
        flexGrow: 1,
        maxWidth: '100%',
        display: item ? display : 'block',
      };
    }

    const width = `${Math.round((gridSize / 12) * 10e7) / 10e5}%`;

    return {
      flexBasis: width,
      flexGrow: 1,
      maxWidth: '100%',
      display: item ? display : 'block',
    };
  };

  displayContents = (isDisplay) => {
    this.setState({ isDisplay: isDisplay });
  };

  render = () => {
    const { children, container, item } = this.props;
    const newProps = { displayContents: this.displayContents };

    const childrenWithProps = React.Children.map(children, (child) => {
      switch (typeof child) {
        case 'string':
          return child;

        case 'object':
          return child === null ? null : React.cloneElement(child, newProps);

        default:
          return null;
      }
    });
    const Wrapper = container ? ContainerBase : item ? ItemBase : 'div';

    return (
      <Wrapper style={item ? this.calcStyle() : {}}>
        {childrenWithProps}
      </Wrapper>
    );
  };
}

export default HomeGrid;
